/**
 * Builds the POST body for version-history `version/version-copy-procedure-tree-node`.
 * That service does not accept source ("from_*") fields; source context lives in
 * audit_trail_data, snapshots, and node_indexing.
 */
export function omitVersionHistoryTreeCopyFromFields(payload) {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  const next = { ...payload };
  Object.keys(next).forEach((key) => {
    if (key.startsWith('from_')) {
      delete next[key];
    }
  });
  return next;
}
